var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.86 53.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m26.91,0h26.94v26.83c0,14.9-12.12,27.02-27.02,27.02H0v-26.94C0,12.07,12.07,0,26.91,0Zm-.08,43.49c9.19,0,16.66-7.47,16.66-16.66V10.36s-16.58,0-16.58,0c-9.13,0-16.55,7.42-16.55,16.55v16.58s16.47,0,16.47,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco);
export default __webpack_public_path__ + "static/media/ico.84aa396a80976d73f10016e8c6b514c4.svg";
export { ForwardRef as ReactComponent };